// ==============================|| OVERRIDES - LINK ||============================== //

export default function Link() {
  return {
    MenuItem: {
      defaultProps: {
        background: "red",
      },
    },
  }
}
